<script>
import axios from 'axios'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'

import comment from '@/helpers/comments/comment.js'

import store from '@/store'

const apiBase = API_APP_PATH + "/v1"

export default {
    props: {
        referencetype: {
            type: String
        },
        referenceid: {
            type: Number
        }
    },
    watch: {
        referenceid: function() {
            if (this.referenceid) { this.getComments(this) }
        }
    },
    data () {
        return {
            comments: [],
            comment: null,
            replies: {}
        }
    },
    mounted() {
        if (this.referenceid) { this.getComments(this) }
    },
    methods: {
        reply(reference) {
            let replies = this.replies

            for (let commentID in replies) {
                if (replies[commentID] && commentID !== reference) {
                    replies[commentID].active = false
                }
            }

            if (!replies[reference]) {
                replies[reference] = { active: true }
            } else {
                replies[reference].active = true
            }

            this.replies = Object.assign({}, this.replies, replies)

        },
        closeReply(reference) {

            let replies = this.replies

            for (let commentID in replies) {
                if (replies[commentID] && commentID == reference) {
                    replies[commentID].active = false
                }
            }

            this.replies = Object.assign({}, this.replies, replies)

        },
        async createComment() {
            if (this.comment === null || this.comment === "") return

            const employeeID = store.getters['getEmployeeId']
            
            const firstName = store.getters['getFirstName']
            const lastName = store.getters['getLastName']

            const options = {
                UserID: employeeID,
                ReferenceID: this.referenceid,
                ReferenceType: this.referencetype,
                Comment: this.comment
            }

            const newComment = comment(options)

            const c = await axios.post(`${apiBase}/data/school/comments/new`, newComment)

            let _date = new Date(c.data.CreateDate)

            let commentWithName = c.data

            commentWithName['FirstName'] = firstName
            commentWithName['LastName'] = lastName
            commentWithName['CreateDate'] = `${distanceInWordsToNow(_date)} ago`

            this.comments.unshift(commentWithName)

            this.comment = ''
        },
        async sendReply(reference) {

            if (this.$refs[reference][0].value.length > 0) {
                
                const employeeID = store.getters['getEmployeeId']

                const firstName = store.getters['getFirstName']
                const lastName = store.getters['getLastName']

                const options = {
                    UserID: employeeID,
                    ReferenceID: this.referenceid,
                    ReferenceType: this.referencetype,
                    Comment: this.$refs[reference][0].value
                }

                const newComment = comment(options, reference)

                console.log('here')

                const c = await axios.post(`${apiBase}/data/school/comments/new`, newComment)

                let comments = this.comments

                for (let i = 0; i < comments.length; i++) {

                    if (comments[i].CommentID === c.data.ParentID) {

                        let _date = new Date(c.data.CreateDate)

                        c.data['FirstName'] = firstName
                        c.data['LastName'] = lastName
                        c.data['CreateDate'] = `${distanceInWordsToNow(_date)} ago`

                        if (!comments[i].Replies) {

                            comments[i].Replies = []
                            comments[i].Replies.push(c.data)
                        } else {
                            comments[i].Replies.push(c.data)
                        }
                    }
                }
                this.$refs[reference][0].value = null
                this.replies = {}
            }
        },
        getComments(context) {
            // setting this to a variable so that its accessible with returned Promise
            let _this = context

            axios.get(`${apiBase}/data/school/comments/${context.referencetype}/${context.referenceid}`)
            .then(function(response) {

                const { data } = response

                if (data) {
                    let commentsWithReplies = data.map(x=> {

                        let _date = new Date(x.CreateDate)

                        x.Replies = data.filter(c => c.ParentID === x.CommentID)
                        x.CreateDate = `${distanceInWordsToNow(_date)} ago`
                        return x
                    }, data).filter(x=> !x.ParentID)

                    _this.comments = commentsWithReplies.sort((a,b) => b.CommentID - a.CommentID)
                }
            })
        }
    }
}
</script>
<template>
    <div class="comments-container">
        <h3>{{comments.length}} Comments</h3>
        <div data-div-type="comments-box">
            <el-input 
                type="textarea"
                autosize
                placeholder="Add a comment..."
                v-model="comment"
            />
            <button :disabled="!comment" @click="createComment">Comment</button>
        </div>
        <ul class="comments" v-if="comments.length > 0">
            <li v-for="comment in comments" :key="comment.CommentID">
                <div class="comments-text">
                    <div>
                        <h2>{{comment.FirstName}} {{comment.LastName}}</h2>
                        <span>{{comment.CreateDate}}</span>
                    </div>
                    <p>{{comment.Comment}}</p>
                </div>
                <div v-if="comment.Replies" class="comments-replies">
                    <ul class="comments-replies-list">
                        <li v-for="reply in comment.Replies" :key="reply.CommentID">
                            <div>
                                <h2>{{reply.FirstName}} {{reply.LastName}}</h2>
                                <span>{{reply.CreateDate}}</span>
                            </div>
                            <p>{{reply.Comment}}</p>
                        </li>
                    </ul>
                </div>
                <div v-if="!replies[comment.CommentID] || (replies[comment.CommentID] && !replies[comment.CommentID].active)" class="comments-reply">
                    <button @click="reply(comment.CommentID)" :ref="comment.CommentID">Reply</button>
                </div>
                <div v-else class="comments-reply-send">
                    <input type="text" :ref="comment.CommentID" />
                    <button @click="sendReply(comment.CommentID)">send</button>
                    <button @click="closeReply(comment.CommentID)">x</button>
                </div>
            </li>
        </ul>
    </div>
</template>
<style lang="scss" scoped>

    .comments-container {
        h3 {
            font-family: 'museo_sans';
        }
        [data-div-type="comments-box"], .comments {
            button {
                padding: 5px 10px;
                width: 100px;
                background-color: #fff !important; 
                cursor: pointer;
            }
        }
        [data-div-type="comments-box"] {
            text-align: right;
            .el-textarea {
                margin-bottom: 2%;
            }
        }
        .comments {
            padding: 0;
            list-style-type: none;
            li {
                margin-bottom: 1em;
                ul {
                    margin-top: 10px;
                    list-style-type: none;
                    padding-left: 20px;
                    li {
                        margin-bottom: 10px;
                    }
                }
            }
        }
        .comments-text {
            h2 {
                margin: 0;
                font-size: 1em;
            }
            p {
                margin: 0;
            }
            div {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5px;
                span {
                    font-family: 'museo_sans', sans-serif;
                    font-size: .8em;
                }
            }
        }
        .comments-replies-list {
            li div {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5px;
                h2 {
                    margin: 0;
                    font-size: 1em;
                }
                span {
                    font-family: 'museo_sans', sans-serif;
                    font-size: .8em;
                }
            }
            p {
                margin: 0;
            }
        }   
        .comments-reply-send {
            display: flex;
            justify-content: space-between;
        }
        button[disabled] {
            cursor: not-allowed;
        }
    }

</style>